import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import styles from './navbar.module.css';

const Navbar = () => {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  const handleLogout = () => {
    instance.logoutPopup().then(() => {
      navigate('/login');
    });
  };

  if (!isAuthenticated) {
    return null;
  }
  return (
    <nav className={styles.navbar}>
      <div className={styles.container}>
        <Link to="/" className={styles.logo}>
          Teams Meeting Manager
        </Link>
        <div className={styles.links}>
          <Link to="/admin" className={styles.link}>Events Manager</Link>
          <Link to="/meetings" className={styles.link}>Events</Link>

          <button onClick={handleLogout} className={styles.logoutButton}>
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;